/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Return_To_SignupInputs */

const en_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Return to Signup`)
};

const fr_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retourner a l'inscription`)
};

const de_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück zur Anmeldung`)
};

const it_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Torna alla registrazione`)
};

const ru_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться к регистрации`)
};

const es_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regresar a Registrarse`)
};

const zh_cn2_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回注册页面`)
};

const ja_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインアップに戻る`)
};

const hi_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइनअप पर वापस जाएं`)
};

const pt_pt2_creator_checkout_return_to_signup = /** @type {(inputs: Creator_Checkout_Return_To_SignupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar ao cadastro`)
};

/**
* | output |
* | --- |
* | "Return to Signup" |
*
* @param {Creator_Checkout_Return_To_SignupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_return_to_signup = /** @type {((inputs?: Creator_Checkout_Return_To_SignupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Return_To_SignupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_return_to_signup(inputs)
	if (locale === "de") return de_creator_checkout_return_to_signup(inputs)
	if (locale === "it") return it_creator_checkout_return_to_signup(inputs)
	if (locale === "ru") return ru_creator_checkout_return_to_signup(inputs)
	if (locale === "es") return es_creator_checkout_return_to_signup(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_return_to_signup(inputs)
	if (locale === "ja") return ja_creator_checkout_return_to_signup(inputs)
	if (locale === "hi") return hi_creator_checkout_return_to_signup(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_return_to_signup(inputs)
	return en_creator_checkout_return_to_signup(inputs)
});